import TextPopup from "@/popups/textPopup";

function getServicesText() {
	if (window.seasonManager.isWinter()) {
		return window.lihe.servicesWinter || window.lihe.services;
	} else {
		return window.lihe.servicesSummer || window.lihe.services;
	}
}

function getDescriptionText() {
	if (window.seasonManager.isWinter()) {
		return (
			window.lihe.generalDescriptionWinter || window.lihe.generalDescription
		);
	} else {
		return (
			window.lihe.generalDescriptionSummer || window.lihe.generalDescription
		);
	}
}

export default async () => {
	// text popups

	const descriptionPopupText = getDescriptionText();
	const descriptionPopup = new TextPopup(
		window.lihe.name,
		descriptionPopupText,
		"description-popup",
		"#description-show-more"
	);
	descriptionPopup.initTextPopup();
	window.descriptionPopup = descriptionPopup;

	const servicesText = getServicesText();
	if (!servicesText) {
		document.querySelector("#services-show-more").style.display = "none";
	} else {
		const servicesPopup = new TextPopup(
			window.content.liheDesc_services,
			servicesText,
			"services-popup",
			"#services-show-more"
		);
		servicesPopup.initTextPopup();
		window.servicesPopup = servicesPopup;
	}

	const transportPopUp = new TextPopup(
		"TRANSPORT",
		"s",
		"transport-popup",
		"#transport-show-more"
	);

	transportPopUp.initTextPopup();
	window.transportPopUp = transportPopUp;
};
